export default {
  name: 'widok warstw',
  buttons: [
    {
      title: 'Włącz/Wyłącz widok warstw',
      key: 'Ctrl+Shift+L'
    }
  ]
}